import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { ArrowRight, Hourglass } from "@phosphor-icons/react";

export default function ComingSoon({ titleKey }) {
  const { t } = useLang();
  const title = t.pillars[titleKey]?.title || t.common.comingSoon;
  const kicker = t.pillars[titleKey]?.kicker || "—";
  const desc = t.pillars[titleKey]?.desc || "";

  return (
    <section className="min-h-[80vh] bg-white relative" data-testid={`coming-soon-${titleKey}`}>
      <div className="absolute inset-0 gm-grid-bg pointer-events-none" />
      <div className="max-w-5xl mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-32 relative">
        <div className="flex items-center gap-4">
          <span className="font-mono text-xs tracking-widest text-[#525252]">{kicker}</span>
          <span className="w-10 h-px bg-[#0A4DFF]" />
          <span className="gm-eyebrow text-[#0A4DFF]">{t.common.comingSoon}</span>
        </div>
        <h1 className="font-display text-5xl md:text-7xl tracking-tighter font-medium mt-8 leading-[0.95]">
          {title}
        </h1>
        <p className="text-lg text-[#525252] mt-6 max-w-2xl leading-relaxed">{desc}</p>

        <div className="mt-14 flex items-center gap-6 border-t border-[#e5e5e5] pt-10">
          <div className="w-14 h-14 bg-[#0a0a0a] text-white flex items-center justify-center">
            <Hourglass size={24} weight="thin" />
          </div>
          <div>
            <h2 className="font-display text-2xl md:text-3xl tracking-tight">{t.comingSoon.title}</h2>
            <p className="text-sm text-[#525252] mt-2 max-w-xl leading-relaxed">{t.comingSoon.sub}</p>
          </div>
        </div>

        <div className="mt-12 flex flex-wrap gap-4">
          <Link to="/instore-data" className="gm-btn gm-btn-primary" data-testid="cs-cta-instore">
            {t.comingSoon.cta} <ArrowRight size={16} />
          </Link>
          <Link to="/" className="gm-btn gm-btn-outline" data-testid="cs-cta-home">
            {t.common.backHome}
          </Link>
        </div>
      </div>
    </section>
  );
}
